export const REDUX_NAMESPACE = 'EDITOR';
